import { formatGs, LOCATION_NAMES, formatDate } from "@/lib/format";

const esc = (s) => String(s ?? "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
const row = (l, r, bold) => `<div class="row${bold ? " b" : ""}"><span>${esc(l)}</span><span>${esc(r)}</span></div>`;
const PAY_LABEL = { efectivo: "Efectivo", tarjeta: "Tarjeta (POS)", transferencia: "Transferencia" };

const CSS = `*{margin:0;padding:0;box-sizing:border-box}body{font-family:'Courier New',monospace;font-size:12px;width:72mm;padding:4mm;color:#000}
h1{font-size:16px;text-align:center}.c{text-align:center}.row{display:flex;justify-content:space-between;gap:6px}.b{font-weight:bold}
.big{font-size:15px}hr{border:none;border-top:1px dashed #000;margin:6px 0}.it{margin:2px 0}.muted{font-size:10px}
@page{size:80mm auto;margin:0}`;

export function printHtml(title, body) {
  const w = window.open("", "_blank", "width=380,height=640");
  if (!w) return false;
  w.document.write(`<html><head><title>${esc(title)}</title><style>${CSS}</style></head><body>${body}</body></html>`);
  w.document.close();
  w.focus();
  setTimeout(() => { w.print(); }, 250);
  return true;
}

const header = (settings, location) =>
  `<h1>NautaPOS</h1><p class="c b">${esc(LOCATION_NAMES[location] || location)}</p>${settings?.ruc ? `<p class="c muted">RUC ${esc(settings.ruc)}</p>` : ""}<hr/>`;

export function ticketHtml(sale, settings) {
  const items = sale.items.map((i) => `<div class="it"><div>${esc(i.name)}</div>${row(`${i.quantity} x ${formatGs(i.price)}`, formatGs(i.price * i.quantity))}</div>`).join("");
  const subtotal = sale.items.reduce((s, i) => s + i.price * i.quantity, 0);
  const pays = Object.entries(sale.payments || {}).map(([k, v]) => row(PAY_LABEL[k] || k, formatGs(v))).join("");
  return `${header(settings, sale.location)}
    ${row("Ticket", "#" + sale.id.slice(0, 8).toUpperCase())}${row("Fecha", formatDate(sale.timestamp))}${row("Cajero", sale.cashier)}<hr/>
    ${items}<hr/>${row("Subtotal", formatGs(subtotal))}${sale.discount ? row("Descuento", "-" + formatGs(sale.discount)) : ""}
    <div class="big">${row("TOTAL", formatGs(sale.total), true)}</div><hr/>
    <p class="b">Forma de pago${Object.keys(sale.payments || {}).length > 1 ? " (mixto)" : ""}</p>${pays}
    ${row("Vuelto", formatGs(sale.change || 0), true)}<hr/>
    <p class="c">${esc(settings?.receipt_footer || "¡Gracias por su compra!")}</p><p class="c muted">Comprobante no válido como factura</p>`;
}

export function zHtml(z, settings) {
  const m = z.by_method;
  const sess = z.sessions.map((s) => `<div class="it">${row(s.opened_by, s.status === "cerrada" ? formatGs(s.difference) : "ABIERTA")}<p class="muted">Inicial ${formatGs(s.opening_amount)} · Esperado ${formatGs(s.expected_cash)}${s.counted_amount != null ? " · Contado " + formatGs(s.counted_amount) : ""}</p></div>`).join("");
  const top = z.top_products.map((p) => row(`${p.quantity} ${p.name}`, formatGs(p.revenue))).join("");
  const t = z.totals;
  return `${header(settings, z.location)}<p class="c b big">CIERRE Z</p><p class="c">${esc(z.date)}</p><hr/>
    ${row("Ventas", z.num_sales)}${row("Total vendido", formatGs(z.total_sales), true)}${z.discounts ? row("Descuentos", formatGs(z.discounts)) : ""}<hr/>
    <p class="b">Por forma de pago</p>${row("Efectivo (neto)", formatGs(m.efectivo))}${row("Tarjeta (POS)", formatGs(m.tarjeta))}${row("Transferencia", formatGs(m.transferencia))}${row("Vuelto entregado", formatGs(z.change_given))}<hr/>
    <p class="b">Caja (${z.sessions.length} turnos)</p>${row("Montos iniciales", formatGs(t.opening))}${row("Ingresos", formatGs(t.ingresos))}${row("Retiros", "-" + formatGs(t.retiros))}${row("Ajustes", formatGs(t.ajustes))}
    ${row("Efectivo esperado", formatGs(t.expected), true)}${row("Efectivo contado", formatGs(t.counted))}${row("Diferencia", formatGs(t.difference), true)}<hr/>
    ${sess ? `<p class="b">Turnos</p>${sess}<hr/>` : ""}${top ? `<p class="b">Productos vendidos</p>${top}<hr/>` : ""}
    <p class="muted c">Generado por ${esc(z.generated_by)} · ${formatDate(z.generated_at)}</p>`;
}
